import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { PATHS } from 'src-ironside/app-routing.module';
import { DynamicContacParam } from 'src-ironside/repositories/supplier.repository';
import { BreadCrumbItem } from 'src-ironside/shared/components/bread-crumb/bread-crumb.component';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

export interface Contact {
    lastModifiedUser: string;
    creationDate: number;
    updatingDate: number;
    firstName: string;
    lastName: string;
    phone: string;
    mobile: string;
    email: string;
    url: string;
    id: string;
    job?: string;
    nameOfEntity?: string;
    address?: string;
}

@Component({
    selector: 'app-contact-page',
    templateUrl: './contact-page.component.html',
    styleUrls: ['./contact-page.component.css'],
})
export class ContactPageComponent implements OnDestroy {
    readonly unsubscribe$ = new Subject();

    loading: boolean = false;
    contacts: Contact[] = [];

    constructor(
        private translate: TranslateService,
        private dynamicDocumentService: DynamicDocumentService
    ) {}

    ngOnInit() {
        this.fetchContacts();
    }

    get breadCrumb() {
        let breadCrumbs: BreadCrumbItem[] = [
            { name: this.translate.instant('Menu.home'), url: PATHS.home_en },
            { name: this.translate.instant('Menu.contact') },
        ];
        return breadCrumbs;
    }

    fetchContacts() {
        this.loading = true;
        const params: DynamicContacParam = {
            collectionName: 'dynamic_contact',
            page: 1,
            pageSize: 100,
            filters: [],
            sort: {},
        };
        this.dynamicDocumentService
            .getContactPage(params)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (res) => {
                    this.contacts = res?.content;
                    this.loading = false;
                },
                error: (err) => {
                    this.loading = false;
                },
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}
